module.exports = __webpack_public_path__ + "static/media/Mobile-Steaming Unit-Services.4a14907d.png";